export interface MeetingInsightThresholds {
  heldAway: {
    minMentions: number
    minAgreementRate: number
  }
  referralAsk: {
    minAsks: number
    minConversionRate: number
  }
  minReliableMeetingCount: number
}

export const MEETING_INSIGHT_THRESHOLDS: MeetingInsightThresholds = {
  heldAway: {
    minMentions: 5,
    minAgreementRate: 25,
  },
  referralAsk: {
    minAsks: 5,
    minConversionRate: 40,
  },
  minReliableMeetingCount: 8,
}
